import { StyledButton as Button, StyledButtonReverse as ButtonReverse } from './Button.styled';

export { ButtonReverse };
export default Button;
